const data = require("./data.json");

const getAttributes = function (iconName, options) {
  const iconOptions = {
    version: "1.1",
    width: data[iconName].width,
    height: data[iconName].height,
    viewBox: `0 0 ${data[iconName].width} ${data[iconName].height}`,
    class: `goo-icon goo-icon-${iconName}`,
    "aria-hidden": "true"
  };
  const attrs = Object.assign({}, iconOptions, options);

  if (options.width || options.height) {
    attrs.width = options.width ? options.width : parseInt(options.height) * data[iconName].width / data[iconName].height;
    attrs.height = options.height ? options.height : parseInt(options.width) * data[iconName].height / data[iconName].width;
  }

  if (options.class) {
    attrs.class = `goo-icon goo-icon-${iconName} ${options.class}`;
  }

  return attrs;
};

const getData = function (iconName) {
  return data[iconName];
};

const getSVG = function (iconName, options = {}) {
  const attributes = getAttributes(iconName, options);
  const attributeStrings = [];

  for (const attributeName of Object.keys(attributes)) {
    attributeStrings.push(`${attributeName}="${attributes[attributeName]}"`);
  }

  return `<svg ${attributeStrings.join(' ')}>${getData(iconName).path}</svg>`;
};

export { getAttributes, getData, getSVG };
